export const TYPE = [
  {
    id: 1,
    name: "Nominee",
    fieldName: "nominee",
  },
  {
    id: 2,
    name: "Guardian",
    fieldName: "guardian",
  },
];
export const Titles = [
  {
    value: "",
    display: "Select",
  },
  {
    display: "Mr.",
    value: "Mr.",
  },
  {
    display: "Ms",
    value: "Ms",
  },
  {
    display: "Mrs",
    value: "Mrs",
  },
  {
    display: "Miss",
    value: "Miss"
  },
  {
    display: "Dr.",
    value: "Dr.",
  },
];
export const applicantRelationships = [
  {
    display: "Select Relationship",
    value: "",
    code: "",
  },
  {
    display: "Brother",
    value: "Brother",
    code: "6",
  },
  {
    display: "Daughter",
    value: "Daughter",
    code: "3",
  },
  {
    display: "Father",
    value: "Father",
    code: "4",
  },
  {
    display: "Granddaughter",
    value: "Granddaughter",
    code: "9",
  },
  {
    display: "Grandfather",
    value: "Grandfather",
    code: "10",
  },
  {
    display: "Grandmother",
    value: "Grandmother",
    code: "11",
  },
  {
    display: "Grandson",
    value: "Grandson",
    code: "8",
  },
  {
    display: "Mother",
    value: "Mother",
    code: "5",
  },
  {
    display: "Sister",
    value: "Sister",
    code: "7",
  },
  {
    display: "Son",
    value: "Son",
    code: "2",
  },
  {
    display: "Spouse",
    value: "Spouse",
    code: "1",
  },
  // {
  //   display: "Not Provided",
  //   value: "Not Provided",
  //   code: "12",
  // },
  {
    display: "Others",
    value: "Others",
    code: "13",
  },
];

export const NOOFNOMINEE = [
  {
    display: "1",
    value: 1,
  },
  {
    display: "2",
    value: 2,
  },
  { display: "3", value: 3 },
];
export const identificationOptions = [
  { value: "", display: "Select Identification Details", show: "" },

  // {
  //   display: "Photograph & Signature",
  //   value: "Photograph & Signature",
  //   show: "",
  // },
  {
    display: "PAN",
    value: "pan",
    show: "Pan Number",
  },
  {
    display: "Aadhar number",
    value: "aadhar",
    show: "Aadhar Number (last 4 digits only)",
  },
  { 
    display: "Driving License",
    value: "drivingLicense",
    show: "Driving License Number",
  },
  // {
  //   display: "Saving bank account number",
  //   value: "bankAcc",
  //   show: "Saving Bank Account Number",
  // },
  // {
  //   display: "Demat account Id",
  //   value: "dpId",
  //   show: "Demat account Id",
  // },
  // {
  //   display: "Proof of identity",
  //   value: "Proof of identity",
  //   show: "",
  // },
];
export const idType = [
  { display: "pan", value: "PAN" },
  { display: "Photograph & Signature", value: "PhotographAndSignature" },
  { display: "aadhar", value: "Aadhaar" },
  { display: "drivingLicense", value: "DrivingLicense" },
  { display: "bankAcc", value: "SavingBankAccountNo" },
  { display: "Proof of identity", value: "ProofofIdentity" },
  { display: "dpId", value: "DematAccountID" },
];
export const Required = [
  "title",
  "firstName",
  "address.addr1",
  "address.pin",
  "birthdate",
  "nomRel",
];
export const ValidationFields = [
  "title",
  "firstName",
  "middleName",
  "lastName",
  "address.addr1",
  "address.addr2",
  "address.addr3",
  "address.addr4",
  "address.pin",
  "birthdate",
  "nomRel",
  "email",
  "phone",
  "IdenDet",
];
export const identityProofOptions = [
  { value: "", display: "Select Proof of Identity" },
  { value: "Aadhar", display: "Aadhar Card" },
  { value: "DrivingLicense", display: "Driving License" },
  { value: "NREGAJobCard", display: "NREGA Job Card" },
  { value: "Passport", display: "Passport" },
  { value: "VotersId", display: "Voters Id" },
];
export const NOMINEE = {
  firstName: "",
  middleName: "",
  lastName: "",
  title: Titles[0].value,
  address: {
    addr1: "",
    addr2: "",
    addr3: "",
    addr4: "",
    city: "",
    state: "",
    pin: "",
  },
  phone: "",
  email: "",
  minor: false,
  guardian: false,
  birthdate: "",
  nomPer: "100",
  nomRel: "",
  aadhar: "",
  bankAcc: "",
  pan: "",
  dpId: "",
  idTyp: "",
  attachment: {},
};
export const areaErrorString = "Area not exist.";
export const finalPayload = {
  acTyp: "",
  dpId: "", //selected dpid to which we ll replicate
  trdOpt: false,
  dpOpt: false,
  trdUpd: false, // if user is updating nominee to trading account
  dpUpd: false,
  attachments: [],
  nominees: [],
};
export const NOMINEEERROR = {
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  guarName: undefined,
  sameName: undefined,
  title: undefined,
  address: {
    addr1: undefined,
    addr2: undefined,
    addr3: undefined,
    addr4: undefined,
    pin: undefined,
  },
  phone: undefined,
  email: undefined,
  birthdate: undefined,
  nomPer: undefined,
  nomRel: undefined,
};

export const AREAOPTIONSTATUS = {
  display: "Select area",
  value: "Select area",
};

export const Relationship = [
  {
    value: "Select Relationship Details",
    display: "Select Relationship Details",
  },
  {
    value: "Spouse",
    display: "Spouse",
  },
  {
    value: "Son",
    display: "Son",
  },
  {
    value: "Daughter",
    display: "Daughter",
  },
  {
    value: "Father",
    display: "Father",
  },
  {
    value: "Mother",
    display: "Mother",
  },
];

export const ageCalculator = (date) => {
  const birth = new Date(date);
  const check = new Date();
  const milliDay = 1000 * 60 * 60 * 24; // a day in milliseconds;
  const ageInDays = (check - birth) / milliDay;
  const age = Math.floor(ageInDays / 365);
  return age;
};

export const toCamelCase = (string) => {
  return string.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const getNestedValue = (x, nominee) => {
  let temp;
  x.split(".").map((u) => {
    if (temp) temp = temp[u];
    else temp = nominee[u];
  });
  return temp;
};
